import { FormattedMessage } from 'react-intl';

import { Button } from '@xing-com/button';
import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { ROUTES } from '@xing-com/crate-jobs-paths';
import { Link } from '@xing-com/link';
import { BodyCopy } from '@xing-com/typography';

import { Title } from './styles';

type Props = {
  onClose: () => void;
  email?: string;
};
export const CreatedAlert: React.FC<Props> = ({ onClose, email }) => {
  const { isLoggedOut } = useLoginState();

  return (
    <>
      <div>
        <Title size="xxlarge">
          <FormattedMessage
            id={
              isLoggedOut
                ? 'JOBS_CREATE_SEARCH_ALERT_HEADER'
                : 'JOBS_CREATED_SEARCH_ALERT_HEADER'
            }
          />
        </Title>
        <BodyCopy noMargin>
          {isLoggedOut ? (
            <FormattedMessage id="JOBS_CREATE_SEARCH_ALERT_SUBSCRIPTION_CONFIRM" />
          ) : (
            <FormattedMessage
              id="JOBS_CREATED_SEARCH_ALERT_PARAGRAPH"
              values={{
                email,
                b: (chunks) => <b>{chunks}</b>,
                a: (chunks) => (
                  <Link
                    to={`${ROUTES.myJobsSearchAlerts}&sc_o=jobs_manage_search_alerts&sc_o_PropActionOrigin=jobs_jdp`}
                  >
                    {chunks}
                  </Link>
                ),
              }}
            />
          )}
        </BodyCopy>
      </div>
      <div>
        <Button variant="primary" size="medium" onClick={onClose}>
          <FormattedMessage id="JOBS_CREATED_SEARCH_ALERT_CONFIRM" />
        </Button>
      </div>
    </>
  );
};
